export const SOF_STATUS: Record<
  string,
  { label: string; color: "default" | "info" | "success" | "warning" | "error" }
> = {
  draft: { label: "Черновик", color: "default" },
  pending: { label: "На проверке", color: "warning" },
  approved: { label: "Одобрена", color: "success" },
  rejected: { label: "Отклонена", color: "error" },
};

export function sofStatus(s: string): { label: string; color: "default" | "info" | "success" | "warning" | "error" } {
  return SOF_STATUS[s] ?? { label: s, color: "default" };
}
